import { TechModalRiskProfileExpireModel } from './../../shared/techmodalRiskProfileExpire/techmodalRiskProfileExpire.model';
import { TechModalRiskProfileExpireComponent } from './../../shared/techmodalRiskProfileExpire/techmodalRiskProfileExpire.component';
import { TranslateService } from '@ngx-translate/core';
import { Component, DoCheck, OnDestroy, OnInit } from '@angular/core';
import { ClientDataApiRestInterface } from '@techrules/portallib';
import { CommonService } from '@tech-services/common.service';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LocalStorageKey, SessionService } from '@tech-services/session.service';
import { Router } from '@angular/router';

@Component({
  selector: 'tech-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, DoCheck, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  showEvaChat = false;
  private readonly publicRoutePrefixes = [
    '/login',
    '/signup',
    '/recover-password',
    '/resetPassword',
    '/register',
    '/agentaccess',
    '/Onboarding',
    '/onboarding',
    '/publicplanner',
  ];

  constructor(
    private translate: TranslateService,
    public dialog: MatDialog,
    private commonService: CommonService,
    private session: SessionService,
    private router: Router
  ) {
    /*this.commonService.clientDataInitialSource
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: ClientDataApiRestInterface) => {
        if (Object.keys(data).length > 0) {
          const _investorProfile = data.InvestorProfile;
          // console.log(_investorProfile);
          if (_investorProfile.TestExpired) {
            this.verifyTestModal();
          }
        }
      });*/
  }

  ngOnInit() {
    this.updateEvaChatVisibility();

    const updateCheckChatInterval = 60000; //AppConfig.settings.
    this.commonService
      .startUpdateCheckChatInterval(updateCheckChatInterval)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          console.log('Checking for new messages...');
          this.commonService.chatListenerSource.next(
            new Date().getMilliseconds().toString()
          );
        },
        (error) => {
          console.error('Error al comprobar actualizaciones:', error);
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngDoCheck(): void {
    this.updateEvaChatVisibility();
  }

  private hasActiveSession(): boolean {
    const token = window.localStorage
      ? window.localStorage.getItem(LocalStorageKey.SESSION_TOKEN)
      : null;

    return !!token && token !== 'undefined' && token !== 'null' && token.trim() !== '';
  }

  private isPublicRoute(url: string): boolean {
    const path = url.split('?')[0].split('#')[0].toLowerCase();
    return this.publicRoutePrefixes.some((prefix) =>
      path.startsWith(prefix.toLowerCase())
    );
  }

  private updateEvaChatVisibility(): void {
    const shouldShow = this.hasActiveSession() && !this.isPublicRoute(this.router.url || '');
    if (this.showEvaChat !== shouldShow) {
      this.showEvaChat = shouldShow;
    }
  }

  /*
  verifyTestModal() {
    const dialogRef = this.dialog.open(TechModalRiskProfileExpireComponent);
  }
  */
}
